import DeviceHubIcon from '@mui/icons-material/DeviceHub'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlineOutlined'
import RepeatIcon from '@mui/icons-material/Repeat'
import BugReportIcon from '@mui/icons-material/BugReport'
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlined'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred'
import Inventory2Icon from '@mui/icons-material/Inventory2'
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner'
import SensorsIcon from '@mui/icons-material/Sensors'
import GroupsIcon from '@mui/icons-material/Groups'
import ReportProblemIcon from '@mui/icons-material/ReportProblem'

// Icono por tipo — un tipo no listado aquí cae en el genérico InfoOutlinedIcon,
// así que añadir un tipo nuevo en el backend (utils/notificationTypes.js)
// nunca rompe la UI, como mucho se ve menos específico hasta que se añada su
// caso aquí. Compartido entre NotificationBell y la página /notifications.
export const NOTIFICATION_TYPE_ICONS = {
    NODE_OFFLINE: DeviceHubIcon,
    NODE_UPDATE_ROLLBACK: ErrorOutlineIcon,
    NODE_CRASH_LOOP: RepeatIcon,
    NODE_CRASHED: BugReportIcon,
    ALARM_DETECTED: LibraryBooksIcon,
    SIP_OPERATION_SUCCESS: CheckCircleOutlineIcon,
    SIP_OPERATION_WARNING: WarningAmberIcon,
    SIP_OPERATION_ERROR: ReportGmailerrorredIcon,
    INVENTORY_CREATED_WEB: Inventory2Icon,
    INVENTORY_CREATED_DEVICE: QrCodeScannerIcon,
    SIGNAL_STATE_CHANGED: SensorsIcon,
    OCCUPANCY_LEVEL_CHANGED: GroupsIcon,
    NODE_COMMAND_FAILED: ReportProblemIcon
}

export const DEFAULT_NOTIFICATION_ICON = InfoOutlinedIcon
